import React from "react";
import { FaArrowLeft, FaBars, FaAngleRight } from "react-icons/fa";
import * as SCREENS from "../constants/screens";
import { useBlueBody } from "../hooks/useBlueBody";

const realFormat = {
  minimumFractionDigits: 2,
  style: "currency",
  currency: "BRL",
};

export default function Results({ dataManager, sidebarManager }) {
  const { data, setData, sendDataToSheet } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    const screen = data.associateMode ? SCREENS.CREDIT : SCREENS.PHONE;

    setData({ ...data, screen: screen });
  }

  function hireCredit(term, termValue) {
    sendDataToSheet(
      data.name,
      data.phone,
      data.associateMode,
      data.redirected,
      data.administrator,
      `${data.name} simulou crédito para ${
        data.finality
      } e quer pegar ${data.credit.toLocaleString(
        "pt-BR",
        realFormat
      )} (${term}x de ${termValue.toLocaleString("pt-BR", realFormat)})`
    );

    window.open(
      `https://api.whatsapp.com/send?phone=5561999869761&text=Ol%C3%A1!%20Meu%20nome%20%C3%A9%20${
        data.name
      }.%20Simulei%20cr%C3%A9dito%20para%20${
        data.finality
      }%20e%20tenho%20interesse%20em%20pegar%20${data.credit.toLocaleString(
        "pt-BR",
        realFormat
      )}%20pagando%20${term}%20parcelas%20de%20${termValue.toLocaleString(
        "pt-BR",
        realFormat
      )}.`
    );
  }

  function newSimulation() {
    sendDataToSheet(
      data.name,
      data.phone,
      data.associateMode,
      data.redirected,
      data.associate,
      `${data.name} viu os resultados e vai fazer uma nova simulação`
    );

    setData({
      ...data,
      credit: "",
      creditMessage: "",
      finality: "",
      category: "",
      results: "",
      minChanged: "",
      screen: SCREENS.ADMINISTRATORS,
    });
  }

  return (
    <section className="administrators-screen">
      <div className="container mb-4">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "100%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-4">
        <h1>Resultado da Simulação</h1>
        <h2>Clique na melhor opção para você.</h2>
      </div>
      <div className="bottom-panel container text-dark">
        <div>
          <h3 className="mb-2">
            {data.finality} - {data.administrator}
          </h3>
          {data.creditMessage !== "" ? (
            <div className="alert alert-primary mb-2" role="alert">
              {data.creditMessage}
            </div>
          ) : null}
          <div
            className="card card-body card-results mb-2"
            role="button"
            tabIndex="0"
            onClick={() =>
              hireCredit(data.results[0].term, data.results[0].termValue)
            }
            onKeyDown={(e) => e.target.onClick}
          >
            <div className="row mb-1 justify-content-between align-items-center">
              <div className="col">
                <p className="mb-0">
                  <strong>
                    Crédito: {data.credit.toLocaleString("pt-BR", realFormat)}
                  </strong>
                </p>
              </div>
              <div className="col-auto">
                <FaAngleRight className="hire-results" />
              </div>
            </div>
            <p className="mb-0">
              <strong>Parcela: </strong>
              {data.results[0].termValue.toLocaleString("pt-BR", realFormat)}
            </p>
            <p className="mb-0">
              <strong>Prazo: </strong>
              {data.results[0].term} meses
            </p>
          </div>
          <div
            className="card card-body card-results mb-2"
            role="button"
            tabIndex="0"
            onClick={() =>
              hireCredit(data.results[1].term, data.results[0].termValue)
            }
            onKeyDown={(e) => e.target.onClick}
          >
            <div className="row mb-1 justify-content-between align-items-center">
              <div className="col">
                <p className="mb-0">
                  <strong>
                    Crédito: {data.credit.toLocaleString("pt-BR", realFormat)}
                  </strong>
                </p>
              </div>
              <div className="col-auto align-middle">
                <FaAngleRight className="hire-results" />
              </div>
            </div>
            <p className="mb-0">
              <strong>Parcela: </strong>
              {data.results[1].termValue.toLocaleString("pt-BR", realFormat)}
            </p>
            <p className="mb-0">
              <strong>Prazo: </strong>
              {data.results[1].term} meses
            </p>
          </div>
          <div
            className="card card-body card-results mb-2"
            role="button"
            tabIndex="0"
            onClick={() =>
              hireCredit(data.results[2].term, data.results[0].termValue)
            }
            onKeyDown={(e) => e.target.onClick}
          >
            <div className="row mb-1 justify-content-between align-items-center">
              <div className="col">
                <p className="mb-0">
                  <strong>
                    Crédito: {data.credit.toLocaleString("pt-BR", realFormat)}
                  </strong>
                </p>
              </div>
              <div className="col-auto">
                <FaAngleRight className="hire-results" />
              </div>
            </div>
            <p className="mb-0">
              <strong>Parcela: </strong>
              {data.results[2].termValue.toLocaleString("pt-BR", realFormat)}
            </p>
            <p className="mb-0">
              <strong>Prazo: </strong>
              {data.results[2].term} meses
            </p>
          </div>
        </div>
        <div className="mt-auto">
          <button
            className="btn btn-primary btn-lg col-12"
            onClick={newSimulation}
          >
            Nova Simulação
          </button>
        </div>
      </div>
    </section>
  );
}
